import { ReactNode } from 'react';
import { Alert, Box } from '@mui/material';

const WARNING_BANNER_COLORS = {
  background: '#fff6e0',
  border: '#e8c765',
  accent: '#d49a00',
  text: '#5d430b'
} as const;

export interface WarningBannerProps {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
}

export const WarningBanner = ({ children, className, dataTestId }: WarningBannerProps) => (
  <Alert
    severity="warning"
    className={className}
    data-testid={dataTestId}
    icon={
      <Box
        sx={{ width: 3, alignSelf: 'stretch', borderRadius: '2px', backgroundColor: WARNING_BANNER_COLORS.accent }}
      />
    }
    sx={{
      gap: '10px',
      py: '12px',
      pl: '14px',
      pr: 2,
      borderRadius: '6px',
      border: `1px solid ${WARNING_BANNER_COLORS.border}`,
      backgroundColor: WARNING_BANNER_COLORS.background,
      color: WARNING_BANNER_COLORS.text,
      fontSize: 13,
      lineHeight: '18px',
      '& .MuiAlert-icon': { display: 'flex', p: 0, mr: 0, opacity: 1 },
      '& .MuiAlert-message': { p: 0 }
    }}>
    {children}
  </Alert>
);
